var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 7.5C4.16675 7.03976 4.53985 6.66666 5.00008 6.66666H15.0001C15.4603 6.66666 15.8334 7.03976 15.8334 7.5V15C15.8334 16.3807 14.7142 17.5 13.3334 17.5H6.66675C5.28604 17.5 4.16675 16.3807 4.16675 15V7.5Z",
    fill: "#FD397A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M4.16675 4.16667C4.16675 3.70644 4.53985 3.33334 5.00008 3.33334H15.0001C15.4603 3.33334 15.8334 3.70644 15.8334 4.16667C15.8334 4.6269 15.4603 5 15.0001 5H5.00008C4.53985 5 4.16675 4.6269 4.16675 4.16667Z",
    fill: "#FD397A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.5 3.33333C7.5 2.8731 7.8731 2.5 8.33333 2.5H11.6667C12.1269 2.5 12.5 2.8731 12.5 3.33333H7.5Z",
    fill: "#FD397A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.f0a194350d285bda02571fe989dac393.svg";
export { ForwardRef as ReactComponent };